import { render, staticRenderFns } from "./RiskyUserRow.vue?vue&type=template&id=247cfb64&scoped=true&"
import script from "./RiskyUserRow.vue?vue&type=script&lang=ts&"
export * from "./RiskyUserRow.vue?vue&type=script&lang=ts&"
import style0 from "./RiskyUserRow.vue?vue&type=style&index=0&id=247cfb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cfb64",
  null
  
)

export default component.exports